import { render, staticRenderFns } from "./receiveableview.vue?vue&type=template&id=4beeffaa&scoped=true&"
import script from "./receiveableview.vue?vue&type=script&lang=js&"
export * from "./receiveableview.vue?vue&type=script&lang=js&"
import style0 from "./receiveableview.vue?vue&type=style&index=0&id=4beeffaa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beeffaa",
  null
  
)

export default component.exports